import getChildrenSelectedCategories from './getChildrenSelectedCategories'
import getPPPDChildrenPrice from './getPPPDChildrenPrice'

const getTotalPPPDRate = (rate, adults, childrenAges) => {
  const { nights, totalRate, pricePerPerson, childrenCategories } = rate

  const childrenSelectedCategories = getChildrenSelectedCategories(childrenAges, childrenCategories)
  const childrenPrice = getPPPDChildrenPrice(childrenSelectedCategories, pricePerPerson, nights)

  const adultsNumber = adults || 0
  const adultPrice = adultsNumber * pricePerPerson * nights
  return totalRate + adultPrice + childrenPrice
}

export default getTotalPPPDRate
